module.exports = __webpack_public_path__ + "img/social.65ee63cc.png";